export default "__VITE_ASSET__f8bdd607__"